<template>
  <el-dialog
    class="dialog-edit-flow"
    :title="title"
    :visible.sync="visible"
    width="400px"
  >
    <ConfigForms
      ref="form"
      labelWidth="110px"
      :formItems="formItems"
      :data="formData"
      inline
    />
    <span slot="footer" class="dialog-footer">
      <el-button @click="close" size="small">取 消</el-button>
      <el-button type="primary" @click="sure" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ConfigForms from "@/components/ConfigForms";
import { statusOptions } from "../config";

const formItems = [
  {
    type: "select",
    label: "状态",
    disabled: true,
    required: true,
    key: "status",
    options: statusOptions,
  },
  { type: "textarea", label: "备注", required: true, key: "remark" },
];

export default {
  name: "EditStatus",
  emit: ["close"],
  components: { ConfigForms },
  data() {
    return {
      visible: false,
      formItems,
      formData: null,
    };
  },
  watch: {},
  computed: {
    isEdit() {
      return !!this.formData;
    },
    title() {
      return this.isEdit ? "退款" : "新增";
    },
  },
  created() {},
  methods: {
    close() {
      this.visible = false;
    },
    open(row) {
      this.formData = null;
      if (row) {
        this.formData = { id: row.id, status: 5 };
      }
      this.visible = true;
    },
    async sure() {
      try {
        const form = await this.$refs.form.validate();
        const data = { ...form };
        this.$emit("sure", { isEdit: this.isEdit, data });
      } catch (error) {
        console.error("sure error:", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-edit-flow {
  /deep/ .el-date-editor.el-input {
    width: 200px;
  }
}
</style>
